var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 345,
    height: 345,
    viewBox: "0 0 345 345",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M122.081 343.184L124.953 344.022L125.744 341.309C139.047 295.666 169.607 259.728 208.514 238.516C247.308 217.098 294.038 210.633 339.68 223.936L342.393 224.726L344.021 219.141L341.308 218.35C295.666 205.047 259.727 174.487 238.516 135.58C217.098 96.786 210.632 50.0565 223.935 4.41367L224.726 1.70063L219.141 0.0726435L218.35 2.78568C205.047 48.4285 174.487 84.3667 135.58 105.579C96.7857 126.996 50.0562 133.462 4.41343 120.159L1.7004 119.368L0.0724108 124.954L2.78544 125.744C48.4283 139.047 84.3665 169.607 105.578 208.514C126.996 247.308 133.461 294.038 120.158 339.681L119.368 342.394L122.081 343.184Z",
    fill: "#2B2A29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecor);
export default __webpack_public_path__ + "static/media/decor.de7705deb1607327bbc4aac7500341b3.svg";
export { ForwardRef as ReactComponent };